import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import withSounds from '../../withSounds';
import './ProfileTabView.css';

const NavLinkWithSounds = withSounds({ mouseEnterSound: true })(NavLink);

class ProfileTabView extends Component {
  render() {
    return (
      <div className="profile-tab-container">
        <NavLinkWithSounds
          to="/rewards"
          className="tab-btn"
          activeClassName="active"
        >
          <span>Your Rewards</span>
        </NavLinkWithSounds>
        {/* Remove Profile Tab header until new ux handles profile. */}
        {/*<NavLinkWithSounds
          to="/profile"
          exact
          className="tab-btn"
          activeClassName="active"
        >
          <span>Your Profile</span>
        </NavLinkWithSounds>*/}
      </div>
    );
  }
}

export default ProfileTabView;



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/ProfileTabView/index.js